export default "../fonts/ab-inspiration-board.svg";